export async function getLatLng(
  place: string
): Promise<{ lat: number; lng: number }> {
  try {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
      place
    )}&limit=1`;

    const res = await fetch(url, {
      headers: {
        "User-Agent": "clone-realtor/1.0 (abdelrahmanmaarouf7@gmail.com)"
      }
    });

    const data = await res.json();

    if (data.length > 0) {
      console.log("data: ", data);
      return {
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon)
      };
    } else {
      // use default coordinates
      return { lat: 30.0444, lng: 31.2357 };
    }
  } catch (error) {
    console.error("Failed to get location: ", error);
    return { lat: 30.0444, lng: 31.2357 };
  }
}
